import React from 'react';
import { Link } from 'react-router-dom';
import { FaEye, FaEdit, FaTrash } from 'react-icons/fa';

import { formatDurationAndTime, dateFormatAndDay } from "../../../Common/appHelper";

import eyeIcon from "../../../../common/images/eyeIcon.png";
import editIcon from "../../../../common/images/editIcon.png";
import trashIcon from "../../../../common/images/trashIcon.png";

const getVehicleColums = (actionFrom, handleDelete, handleViewDetail) =>  {
  if(actionFrom === 'list') {
      return [
              {
                key: 'vehicleNo',
                label: 'VEHICLE DETAILS',
                render: (row) => {
                  const vehicleNo = row.vehicleNo ?? '';
                  const model = row.model ?? '';
                  const vehicleType = row.type ?? '';

                  return (
                    <>
                      <span className='vehicle-no-txtbk'>{vehicleNo}</span>{' '}
                      {vehicleType === 'Bike' && (
                        <span className="vehicle-type1">Bike</span>
                      )}
                      {vehicleType === 'Car' && (
                        <span className="vehicle-type2">Car</span>
                      )}
                      {vehicleType === 'Truck' && (
                        <span className="vehicle-type3">Truck</span>
                      )}
                      <div className='vehicle-model-txt'>{model}</div>
                    </>
                  );
                },
              },
              {
                key: 'ownerName',
                label: 'OWNER DETAILS',
                render: (row) => row.ownerName || '',
              },
              {
                key: 'manufacturer',
                label: 'BUNK DETAILS',
                render: (row) => {
                  const entityName = row.entityName ?? '';
                  const entityDistrict = row.entityDistrict ?? '';
                  const entityState = row.entityState ?? '';

                  return (
                    <>
                      <span className="agency-name-txt">{entityName}</span>
                      <div className="agency-address1-txt">{entityDistrict}, {entityState}</div>
                    </>
                  );
                },
              },
              {
                key: 'inTime',
                label: 'STOPPAGE DURATION',
                render: (row) => {
                  const inTime = row.inTime ?? '';
                  const outTime = row.outTime ?? '';
                  const durationArr = formatDurationAndTime(inTime,outTime);
                  return (
                    <>
                      <span className="agency-name-txt">{durationArr.minstext}</span>
                      <div className="agency-address1-txt">{durationArr.timestrng}</div>
                    </>
                  );
                },
              },
              {
                key: 'fuel',
                label: 'FUEL DETAILS',
                render: (row) => {
                  const fuelValue = row.fuelQuantityLitre ?? '';
                  const fuel = row.fuel ?? '';

                  return (
                    <>
                      <span className="agency-name-txt text-uppercase">{fuel}</span>
                      <div className="agency-address1-txt">{(fuelValue && parseFloat(fuelValue))?fuelValue+" litres":''}</div>
                    </>
                  );
                },
              },
              {
                key: 'amount',
                label: 'PAYMENT DETAILS',
                render: (row) => {
                  const amount = row.amount ?? '';
                  const paymentType = row.paymentType ?? '';

                  return (
                    <>
                      <span className="agency-name-txt">{amount}</span>
                      <div className="agency-address1-txt">{paymentType}</div>
                    </>
                  );
                },
              },
              {
                key: 'actions',
                label: 'ACTION',
                render: (row) => (
                  <>
                    <span
                      onClick={() => handleViewDetail(row)}
                      title="View Details"
                      role="button"
                      className="text-secondary me-2"
                      style={{ cursor: 'pointer' }}
                    >
                      <img src={eyeIcon} className='action-icons eye-icon' alt='eyeIcon' />
                    </span>
                  </>
                ),
              },
            ];
  } else {
        return [
              {
                key: 'inTime',
                label: 'DATE',
                render: (row) => {
                  const inTime = row.inTime ?? '';
                  const dateFrmtArr = dateFormatAndDay(inTime);

                  return (
                    <>
                      <span className="agency-name-txt">{dateFrmtArr.formatteddate}</span>
                      <div className="agency-address1-txt">{dateFrmtArr.daystrng}</div>
                    </>
                  );
                },
              },
              {
                key: 'manufacturer',
                label: 'BUNK DETAILS',
                render: (row) => {
                  const entityName = row.entityName ?? '';
                  const entityDistrict = row.entityDistrict ?? '';
                  const entityState = row.entityState ?? '';

                  return (
                    <>
                      <span className="agency-name-txt">{entityName}</span>
                      <div className="agency-address1-txt">{entityDistrict}, {entityState}</div>
                    </>
                  );
                },
              },
              {
                key: 'ownerName',
                label: 'OWNER DETAILS',
                render: (row) => row.ownerName || '',
              },
              {
                key: 'inTime',
                label: 'STOPPAGE DURATION',
                render: (row) => {
                  const inTime = row.inTime ?? '';
                  const outTime = row.outTime ?? '';
                  const durationArr = formatDurationAndTime(inTime,outTime);
                  return (
                    <>
                      <span className="agency-name-txt">{durationArr.minstext}</span>
                      <div className="agency-address1-txt">{durationArr.timestrng}</div>
                    </>
                  );
                },
              },
              {
                key: 'fuel',
                label: 'FUEL DETAILS',
                render: (row) => {
                  const fuelValue = row.fuelQuantityLitre ?? '';
                  const fuel = row.fuel ?? '';

                  return (
                    <>
                      <span className="agency-name-txt text-uppercase">{fuel}</span>
                      <div className="agency-address1-txt">{(fuelValue && parseFloat(fuelValue))?fuelValue+" litres":''}</div>
                    </>
                  );
                },
              },
              {
                key: 'amount',
                label: 'PAYMENT DETAILS',
                render: (row) => {
                  const amount = row.amount ?? '';
                  const paymentType = row.paymentType ?? '';

                  return (
                    <>
                      <span className="agency-name-txt">{amount}</span>
                      <div className="agency-address1-txt">{paymentType}</div>
                    </>
                  );
                },
              },
            ];
  }
}

export default getVehicleColums;